<template>
  <div class="swiper">
    <div class="swiper-view" ref="swiperView" :style="styleObj">
      <slot></slot>
    </div>
    <ul class="point-warpper" v-if="childrenLen > 1">
      <li @click="handleClick('point',index)" v-for="(item,index) in childrenLen" :key="index" :class="[{active:index == posIndex}]"></li>
    </ul>
  </div>
</template>
<script>
let timer = null;
export default {
  name: "Swiper",
  props: {
    time: {
      type: Number,
      default: 5000
    },
    notransform: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      childrenLen: 0,
      pointArr: [],
      posIndex: 0
    };
  },
  computed: {
    styleObj() {
      const per = 100 * (this.posIndex / this.childrenLen);
      console.log('----', this.notransform)
      return !this.notransform ? {
        width: `${this.childrenLen}00%`,
        transform: `translateX(-${per}%)`
      } : {};
    }
  },
  methods: {
    startScroll() {
      this.stopScroll()
      timer = setInterval(() => {
        ++this.posIndex;
        if (this.posIndex === this.childrenLen) {
          this.posIndex = 0;
        }
      }, this.time);
    },
    stopScroll() {
      clearInterval(timer)
      timer = null;
    },
    handleClick(type, payload) {
      switch (type) {
        case "point":
          const index = payload
          this.stopScroll()
          this.posIndex = index
          this.startScroll()
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    const children = this.$refs.swiperView.children;
    this.childrenLen = children.length;
    this.pointArr = new Array(this.childrenLen);
    this.startScroll();
  }
};
</script>
<style lang="scss" scoped>
.swiper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .swiper-view {
    display: flex;
    height: 100%;
    transition: all 1s;
  }
  .point-warpper {
    position: absolute;
    bottom: 10px;
    left: 50%;
    display: flex;
    transform: translateX(-50%);
    z-index: 10;
    > li {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      flex: 1;
      margin-right: 5px;
      border: 1px solid #fff;
      &.active {
        background-color: #fff;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &.whatsapp {
    .point-warpper > li {
      border: 1px solid #666;
      &.active {
        background-color: #FF7226;
        border-color: #FF7226;
      }
    }
  }
}
</style>


